module.exports = __webpack_public_path__ + "img/content_mo_ui3.0e8fc85a.png";